<template>
    <apexchart height="200" type="area" :options="chartOptions" :series="chartSeries"></apexchart>
</template>

<script setup>
import { ref, defineProps, onMounted, watch, computed } from "vue";

const props = defineProps({
    data: Object,
    color: {
        type: String,
        default: '#583a8e'
    },
})

import { useAuthStore } from '@/stores/AuthStore';
const authStore = useAuthStore();

let endColor = ref('#fff');

onMounted(() => {
    if(authStore.user.dark == 1){
        endColor.value = '#2e333d';
    } else {
        endColor.value = '#fff';
    }
});

const chartSeries = computed(() => {
    if (!props.data || !props.data.values) return [];

    return [{
        name: 'Visitas',
        data: props.data.values
    }];
});

const chartOptions = ref({
    chart: {
        id: 'report_page_chart',
        toolbar: {
            show: false,
        },
        parentHeightOffset: 0,
    },
    grid: {
        show: false,
    },
    yaxis: {
        labels: {
            formatter: function (value) {
                // Formatação para milhões
                if (Math.abs(value) >= 1000000) {
                    return (Math.abs(value) / 1000000).toFixed(1) + "m";
                }
                // Formatação para milhares
                else if (Math.abs(value) >= 1000) {
                    return (Math.abs(value) / 1000).toFixed(1) + "k";
                }
                // Formatação para valores menores
                else {
                    return (value == 0) ? '0' : value;
                }
            },
            style: {
                colors: ["#8f8f8f"],
                fontSize: "11px",
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        shared: false,
        x: {
            formatter: function (value) {
                if (props.data && props.data.dates && props.data.dates[value - 1]) {
                    return props.data.dates[value - 1];
                }
                return value;
            },
        },
        y: {
            formatter: function(value) {
                // Formatar o número com separador de milhares no tooltip
                return new Intl.NumberFormat('pt-BR').format(value);
            }
        }
    },
    xaxis: {
        categories: props.data?.dates || [],
        labels: {
            style: {
                colors: "#8f8f8f",
                fontSize: "11px",
            },
        },
        axisBorder: {
            show: false,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 95, 100],
            colorStops: [
                {
                    offset: 0,
                    color: props.color,
                    opacity: 1
                },
                {
                    offset: 100,
                    color: endColor,
                    opacity: 1
                },
            ]
        },
    },
    colors: [props.color],
});

// Atualiza as categorias quando os dados mudam
watch(() => props.data, (newData) => {
    if (newData && newData.dates) {
        chartOptions.value.xaxis.categories = newData.dates;
    }
}, { deep: true });
</script>
